import { LoadingState } from "@material-dev/insights-portal-ui-components/lib/types";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { IModificationsClient, ModificationsClient } from "app/ApiClient";
import { initialImportInstructionState } from "./ImportInstructionState";

const modificationClient: IModificationsClient = new ModificationsClient(process.env.REACT_APP_API_URL);

export const importInstruction = createAsyncThunk(
  "importInstruction/importInstruction",
  async (
    {
      destProjectId,
      destVersionId,
      sourceModificationId,
      sourceProjectId,
    }: {
      destProjectId: number;
      destVersionId: string;
      sourceProjectId: number;
      sourceModificationId: number;
    },
    { rejectWithValue },
  ) => {
    try {
      const result = await modificationClient.importInstruction(
        sourceProjectId,
        sourceModificationId,
        destProjectId,
        destVersionId,
      );
      return result;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const getImportInstructions = createAsyncThunk(
  "importInstrctions/getImportInstructions",
  async (
    {
      destProjectId,
      destVersionId,
      sourceModificationId,
      sourceProjectId,
    }: {
      destProjectId: number;
      destVersionId: string;
      sourceProjectId: number;
      sourceModificationId: number;
    },
    { rejectWithValue },
  ) => {
    try {
      const response = await modificationClient.getImportInstructions(
        sourceProjectId,
        sourceModificationId,
        destProjectId,
        destVersionId,
      );
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);
const importInstructionSlice = createSlice({
  name: "importInstructions",
  initialState: initialImportInstructionState,
  reducers: {
    resetImportInstructions: () => initialImportInstructionState,
  },
  extraReducers: (builder) => {
    // getImportInstructions
    builder.addCase(getImportInstructions.pending, (state) => {
      state.loading = LoadingState.pending;
      state.errorMessage = undefined;
      state.data = {};
    });
    builder.addCase(getImportInstructions.fulfilled, (state, { payload }) => {
      state.loading = LoadingState.succeed;
      state.data = payload;
    });
    builder.addCase(getImportInstructions.rejected, (state, { error }) => {
      state.loading = LoadingState.failed;
      state.errorMessage = error.message;
    });

    // importInstruction
    builder.addCase(importInstruction.pending, (state) => {
      state.importLoading = LoadingState.pending;
      state.resultModification = null;
      state.errorMessage = undefined;
    });
    builder.addCase(importInstruction.fulfilled, (state, { payload }) => {
      state.importLoading = LoadingState.succeed;
      state.resultModification = payload;
    });
    builder.addCase(importInstruction.rejected, (state, { error }) => {
      state.importLoading = LoadingState.failed;
      state.errorMessage = error.message;
    });
  },
});
export const { resetImportInstructions } = importInstructionSlice.actions;
export default importInstructionSlice.reducer;
